import { render, staticRenderFns } from "./FormShape.vue?vue&type=template&id=4b04b200&"
import script from "./FormShape.vue?vue&type=script&lang=js&"
export * from "./FormShape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports